"use client"

import { useCart } from "@/lib/context/cart-context"
import { Store, Truck } from "lucide-react"

export default function FulfillmentToggle() {
  const { fulfillmentType, setFulfillmentType } = useCart()

  return (
    <div className="inline-flex items-center rounded-full border border-gray-300 bg-white p-0.5 shadow-sm">
      <button
        onClick={() => setFulfillmentType("pickup")}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${fulfillmentType === "pickup" 
          ? "bg-primary_green text-white" 
          : "text-gray-500 hover:text-primary_green hover:bg-gray-50"
        }`}
      >
        <Store className="h-3.5 w-3.5" />
        Pickup
      </button>
      <button
        onClick={() => setFulfillmentType("delivery")}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${fulfillmentType === "delivery" 
          ? "bg-primary_green text-white" 
          : "text-gray-500 hover:text-primary_green hover:bg-gray-50"
        }`}
      >
        <Truck className="h-3.5 w-3.5" />
        Delivery
      </button>
    </div>
  )
}
